import { render, staticRenderFns } from "./sidebar-otp.vue?vue&type=template&id=0bfde00e&scoped=true&"
import script from "./sidebar-otp.vue?vue&type=script&lang=js&"
export * from "./sidebar-otp.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-otp.vue?vue&type=style&index=0&id=0bfde00e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfde00e",
  null
  
)

export default component.exports